module.exports = __webpack_public_path__ + "img/shift.1eedacca.png";